import * as tslib_1 from "tslib";
import { View } from '../ui/view';
var Toggle = /** @class */ (function (_super) {
    tslib_1.__extends(Toggle, _super);
    function Toggle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { open: !!_this.attrs.defaultValue };
        return _this;
    }
    Toggle.prototype.render = function () {
        var _this = this;
        var children = this.attrs.children;
        return children({
            value: this.state.open,
            toggle: function () {
                _this.setState(function (_a) {
                    var open = _a.open;
                    return ({ open: !open });
                });
            },
            set: function (open) { return _this.setState({ open: open }); }
        });
    };
    return Toggle;
}(View));
export { Toggle };
